module.exports = __webpack_public_path__ + "media/dorobek/assets/images/icons/N-158e611280717c315914965fd41ae1dd.svg";